import React from 'react'

const Subheader = () => {
    const dark = () => {
        // dtheme ? setDtheme(false) : setDtheme(true)
        document.querySelector("body").classList.toggle("darkmode")
        let darktheme = "false"
        if (document.body.classList.contains("darkmode")) {
            darktheme = "true"
        }
        localStorage.setItem("darktheme", darktheme)
    }
    // const [dtheme, setDtheme] = React.useState(false)
    return (
      <div className="subheader">
        <div className="container px-xl-3 px-xxl-5">
          <div className="d-flex justify-content-between align-items-center w-100 px-xxl-3 px-xxxl-5">
            <a
              href="https://dlakierowcow.orlen.pl/"
              target="_blank"
              rel="noreferrer"
            >
              dlakierowcow.orlen.pl
            </a>
            <div>
              <button className="js-switch p-0" onClick={() => dark()}>
                <div className="switch">
                  <span className="switch-indicator"></span>
                </div>
                high contrast
              </button>
              <a
                href="../"
                rel="noreferrer"
                className="ml-3"
              >
                PL
              </a>
            </div>
          </div>
        </div>
      </div>
    )
}

export default Subheader
